module.exports = __webpack_public_path__ + "img/error-404.5a681147.png";